<!--
 * @Author: your name
 * @Date: 2019-06-18 20:50:59
 * @LastEditTime : 2020-01-08 16:12:19
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\POISearch\UCPOIResult.vue
 -->
<!--  -->
<template>
  <div style="height:100%">

    <div class="div_title">搜索</div>

    <UCPOIResultPaging ref="ucResultPaging"></UCPOIResultPaging>
  </div>
</template>

<script>
import UCPOIResultPaging from "./UCPOIResultPaging.vue";
import { UCPOIResultParams } from "./UCPOISearchJs.js";

export default {
  name: "",
  data() {
    return {
      resultParams: new UCPOIResultParams()
    };
  },

  components: {
    UCPOIResultPaging
  },

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (this.resultParams) {
        let curFilter = this.resultParams.getPOIFilter();
        this.$refs.ucResultPaging.curFilter = curFilter;
      }
      
      this.$refs.ucResultPaging.init();
    },

    //搜索结果面板改变事件监听者绑定
    on_searchResultChange(callback) {
      this.$refs.ucResultPaging.on_searchResultChange(callback);
    },

    /**
     * @description:
     * @param {type}
     * @return:
     */
    on_poiItemClick(callback) {
      this.$refs.ucResultPaging.on_poiItemClick(callback);
    },

    on_poiItemMouseOver(callback) {
      this.$refs.ucResultPaging.on_poiItemMouseOver(callback);
    },

    /**
     * @description:
     * @param {type}
     * @return:
     */
    on_poiItemMouseOut(callback) {
      this.$refs.ucResultPaging.on_poiItemMouseOut(callback);
    }
  }
};
</script>
<style lang="scss" scoped >

.div_title {
    text-align: center;
    width: 100%;
    max-height: 5%;
    height: 30px;
    font-size: 16px;
    font-weight: 700;
    line-height: 30px;
  }

</style>